import { type Search } from '@vakantiesnl/types/src';

export const CAROUSEL_STEP_SIZE = 3;

function calculateOffset(preselectedIndex: number, itemsPerPage: number, totalItems: number): number {
	const idealStart = Math.max(0, preselectedIndex - Math.floor(itemsPerPage / 2));
	let offset = Math.floor(idealStart / CAROUSEL_STEP_SIZE) * CAROUSEL_STEP_SIZE;
	const maxOffset = Math.max(0, totalItems - itemsPerPage);

	offset = Math.min(offset, maxOffset);

	return offset;
}

export function getOfferOffset(
	selectedOffer: Search.OfferItem | Search.AccommodationOnlyOffer | undefined,
	departureDateOffers: (Search.OfferItem | Search.AccommodationOnlyOffer)[] | undefined,
	carouselRange: number,
): number {
	if (!departureDateOffers?.length) return 0;

	const highlightItem = selectedOffer?.departureDateYYYYMMDD;

	let index = departureDateOffers.findIndex(({ departureDateYYYYMMDD }) => highlightItem === departureDateYYYYMMDD);

	if (index === -1) {
		const minPrice = Math.min(...departureDateOffers.map(({ priceTotal }) => priceTotal));
		index = departureDateOffers.findIndex(({ priceTotal }) => priceTotal === minPrice);
	}

	if (index < 0) return 0;

	const offset = calculateOffset(index, carouselRange, departureDateOffers.length);

	return offset;
}
